import graphql, { getData, getResult, mapErrorsToFormFields } from 'api/graphql'

export const basicFields = `
  id
  gid
  name
  email
  forward_email_address
  from_name
  folders {
    id
    name
    type
  }
  channel_type
  state
  color
`

export const query = mailboxId => `
  query MailboxQuery {
    mailbox(id: "${mailboxId}") {
      ${basicFields}
    }
  }
`

export const collectionQuery = () => `
  query MailboxesQuery {
    mailboxes {
      ${basicFields}
    }
  }
`

export const basicCreationResponseFields = `
  id
  name
  email
  forward_email_address
  channel_type
`

function generateCreateMutation(responseFields) {
  return `
    mutation CreateMailbox($input: MailboxInput!) {
      createMailbox(input: $input) {
        ${responseFields}
      }
    }
  `
}

function generateUpdateMutation(responseFields) {
  return `
    mutation UpdateMailbox($id: ID!, $input: MailboxInput!) {
      updateMailbox(id: $id, input: $input) {
        ${responseFields}
      }
    }
  `
}

const DESTROY_MUTATION = `
  mutation destroyMailbox($id: ID!) {
    destroyMailbox(id: $id) {
      id
    }
  }
`

function generateConvertToDemoMutation(responseFields) {
  return `
    mutation convertToDemoMailbox($id: ID!) {
      convertToDemoMailbox(id: $id) {
        ${responseFields}
      }
    }
  `
}

export const createMailbox = (
  token,
  mailbox,
  responseFields = basicCreationResponseFields
) => {
  return graphql(token, generateCreateMutation(responseFields), {
    input: mailbox,
  })
    .then(getData)
    .then(getResult('createMailbox'))
    .catch(mapErrorsToFormFields)
}

export const updateMailbox = (
  token,
  id,
  mailbox,
  responseFields = basicFields
) => {
  const updatedMailbox = { ...mailbox }
  delete updatedMailbox.forward_email_address
  delete updatedMailbox.id
  return graphql(token, generateUpdateMutation(responseFields), {
    id,
    input: updatedMailbox,
  })
    .then(getData)
    .then(getResult('updateMailbox'))
    .catch(mapErrorsToFormFields)
}

export const destroyMailbox = (token, id) => {
  return graphql(token, DESTROY_MUTATION, { id })
    .then(getData)
    .then(getResult('destroyMailbox'))
    .catch(mapErrorsToFormFields)
}

export const convertMailboxToDemo = (
  token,
  id,
  responseFields = basicFields
) => {
  return graphql(token, generateConvertToDemoMutation(responseFields), { id })
    .then(getData)
    .then(getResult('convertToDemoMailbox'))
    .catch(mapErrorsToFormFields)
}

export const fetchMailbox = (token, id) => {
  return graphql(token, query(id))
    .then(getData)
    .then(getResult('mailbox'))
}
